<template>
  <div class="full">
    <div class="content flex-container">
      <div class="flex-child main">
        <h2>
          <img src="../assets/title5@2x.png" width="500" alt="おいしいだけでは物足りない。"><br>
        </h2>
      </div>
      <div class="flex-child">
        <p class="sub">
          五島の自然に育まれたごと芋は、<br>
          日本でも最高峰の品質を誇るサツマイモです。<br>
          その芋を贅沢につかったポタージュは、<br>
          やさしくて飲みやすいだけでなく、<br>
          濃厚で食べごたえもあります。<br>
          食べればわかるそのやさしさと濃厚さは、<br>
          食べてみないとわかりません。<br>
          食べたことがない方にも、<br>
          そのやさしさと濃厚さを伝えたい。<br>
          そう考えて、もっと気軽に味わうことができる、<br>
          やさしくて濃厚なコンテンツをご用意しました。<br>
          五島が育むやさしさと濃厚さをお楽しみいただき、<br>
          いつの日か島に足を運んでいただければ幸いです。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Copy',
}
</script>

<style scoped>
.full{
  width: 100%;
  height: 100%;
}
.main{
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0.2em;
  position: relative;
}
.sub{
  margin: 0;
  letter-spacing: 0.1em;
  font-weight: bold;
  line-height: 1.8;
  padding-left: 10px;
  margin-left: 50px;
}

h2{
  font-size: 40px;
  position: relative;
  top: 50%;
  transform: translateY(-70%);
  width: 100%;
  padding-right: 30px;
}
h2 img{
  max-width:100%;
}
.content{
  padding: 120px 8vw 120px 8vw;
}
.flex-child{
  flex-basis: 50%
}

@media screen and (max-width:1396px){
  .content{
    padding: 120px 8vw 120px 8vw;
  }
  .sub{
    margin-left: 25px;
  }
}
@media screen and (max-width:970px){
  .content{
    padding: 100px 20px 70px;
  }
  .sub{
    margin-left: 0;
  }
  h2{
    position: static;
    top: auto;
    transform: none;
    padding-right: 0;
  }
  .flex-container{
    display:block;
  }
  .flex-child{
    width: 400px;
    margin: 0 auto;
  }
  .flex-child + .flex-child{
    margin-top: 80px;
  }
  img{
    max-width: 100%;
  }
}
@media screen and (max-width:440px){
  .content{
    padding: 50px 20px 40px;
  }
  .flex-child{
    width: 100%;
    margin: 0 auto;
  }
  .flex-child + .flex-child{
    margin-top: 30px;
  }
  .main{
    font-size: 30px;
  }
  h2{
    font-size: 20px;
  }
  .sub{
    font-size: 14px;
  }
}
@media screen and (max-width:375px){
  .main{
    font-size: 26px;
  }
  h2{
    font-size: 18px;
  }
  .sub{
    font-size: 12px;
  }
}
@media screen and (max-width:365px){
  .main{
    font-size: 24px;
  }
  h2{
    font-size: 18px;
  }
  .sub{
    font-size: 11px;
  }
}
</style>
